export default "__VITE_ASSET__c30fe948__"